var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08938 15.4992C5.71097 14.6486 5.5 13.7023 5.5 12.7051C5.5 9.00154 8.41015 5.99921 12 5.99921C15.5899 5.99921 18.5 9.00154 18.5 12.7051C18.5 13.7023 18.289 14.6486 17.9106 15.4992",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.49921V3.49921",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.4992H21",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.4992H2",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0704 5.42792L18.3633 6.13503",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6368 6.136L4.92969 5.42889",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.517 19.8056C15.5274 19.4788 15.9326 18.554 16.0466 17.6238C16.0806 17.3459 15.852 17.1154 15.572 17.1154L8.47686 17.1156C8.18726 17.1156 7.95468 17.3614 7.98926 17.6489C8.10091 18.5773 8.38271 19.2555 9.45346 19.8056M14.517 19.8056C14.517 19.8056 9.62972 19.8056 9.45346 19.8056M14.517 19.8056C14.3955 21.7506 13.8338 22.5209 12.0068 22.4993C10.0526 22.5354 9.60304 21.5833 9.45346 19.8056",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea01);
export default __webpack_public_path__ + "static/media/idea-01.6eff45f1e3372146f8d8ede69b26eaf1.svg";
export { ForwardRef as ReactComponent };